var React = require('react');

function CircleTick (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"5","fillOpacity":"0"},[React.createElement("path",{"d":"M70.84,27.85A35,35,0,1,1,55.16,7.05","key":0}),React.createElement("polyline",{"className":"cls-2","points":"23.82 30.32 36.83 43.54 72.08 9.13","key":1})]));
}

CircleTick.defaultProps = {"className":"svg-circle-tick","viewBox":"-10 -10 90 90"};

module.exports = CircleTick;

CircleTick.default = CircleTick;
